import Resume from '../components/resume';


export default Resume;